import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalDisclaimer: React.FC = () => {
  const { language } = useTheme();

  // TODO: Replace with CEO's provided "EARNINGS DISCLAIMER & TECHNOLOGICAL LIMITATIONS" text
  // Insert the full text provided by the CEO here
  const disclaimerText = `
EARNINGS DISCLAIMER & TECHNOLOGICAL LIMITATIONS

[CEO's text to be inserted here - Please replace this placeholder with the actual 
"EARNINGS DISCLAIMER & TECHNOLOGICAL LIMITATIONS" text provided by the CEO]

This document contains classified operational protocols and technological limitations
governing the deployment of FORCEP infrastructure systems.

All information contained herein is subject to the sovereign architecture protocols
established by FORCEP FÁBRICA LAB operations.

END OF TRANSMISSION
  `.trim();

  return (
    <div className="min-h-screen bg-black text-white font-mono pt-20 pb-12 px-4 md:ml-24">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8 border-b border-white/20 pb-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors text-xs uppercase tracking-widest mb-6"
          >
            <ArrowLeft className="w-4 h-4" />
            {language === 'en' ? 'RETURN TO HQ' : 'VOLVER A HQ'}
          </Link>
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-2">
            {language === 'en' ? 'CLASSIFIED DOCUMENT' : 'DOCUMENTO CLASIFICADO'}
          </div>
          <h1 className="text-2xl md:text-3xl font-mono font-bold uppercase tracking-wider mb-2">
            {language === 'en' ? 'PROTOCOL DISCLAIMER' : 'DESCARGO DE PROTOCOLO'}
          </h1>
          <div className="text-[9px] text-white/30 uppercase tracking-widest">
            {language === 'en' ? 'FOR INTERNAL OPERATIONS USE ONLY' : 'SOLO PARA USO DE OPERACIONES INTERNAS'}
          </div>
        </div>

        {/* Document Body - Classified Document Style */}
        <div className="bg-black border-2 border-white/20 p-8 md:p-12 relative">
          {/* Top border accent */}
          <div className="absolute top-0 left-0 right-0 h-[2px] bg-white/30"></div>
          
          {/* Document content with strict monospace spacing */}
          <pre className="whitespace-pre-wrap text-xs md:text-sm leading-[1.8] text-white font-mono tracking-[0.05em] font-normal">
            {disclaimerText}
          </pre>
          
          {/* Bottom border accent */}
          <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-white/30"></div>
        </div>

        {/* Footer Stamp */}
        <div className="mt-8 pt-6 border-t border-white/10 text-[9px] text-white/30 uppercase tracking-widest text-center space-y-1">
          <div>
            {language === 'en' ? 'FORCEP FÁBRICA LAB' : 'LABORATORIO FORCEP FÁBRICA'}
          </div>
          <div className="text-white/20">
            {language === 'en' ? 'CLASSIFIED - DO NOT DISTRIBUTE' : 'CLASIFICADO - NO DISTRIBUIR'}
          </div>
          <div className="text-white/10 text-[8px] mt-2">
            {language === 'en' ? 'DOCUMENT REFERENCE: LEGAL-001' : 'REFERENCIA DOCUMENTO: LEGAL-001'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalDisclaimer;
